module.exports = __webpack_public_path__ + "img/photo-18.cda17b03.jpg";